"use client";

import React, { useMemo, useState } from "react";
import {
    TrendingUp,
    ShieldCheck,
    Ban,
    Clock3,
    ChevronDown,
    ChevronUp,
} from "lucide-react";

const MatchOdds = ({ data }) => {
    console.log(JSON.stringify(data), "ooo");

    const odds = data?.live_odds || [];
    const info = data?.info || {};

    const [openCategory, setOpenCategory] = useState(null);

    // Group odds by odd_name
    const groupedOdds = useMemo(() => {
        return odds.reduce((acc, item) => {
            if (!acc[item.odd_name]) {
                acc[item.odd_name] = [];
            }

            acc[item.odd_name].push(item);

            return acc;
        }, {});
    }, [odds]);

    const categories = Object.keys(groupedOdds);

    return (
        <div className="w-full rounded-3xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 shadow-sm overflow-hidden mt-4">
            {/* Header */}
            <div className="px-5 py-4 border-b border-zinc-100 dark:border-zinc-800 flex items-center justify-between">
                <div>
                    <h2 className="text-lg font-bold text-zinc-900 dark:text-white">
                        Match Odds
                    </h2>
                </div>
            </div>
            {/* Odds Categories */}
            <div className="space-y-4  p-4" style={{maxHeight:'500px', overflow:'auto'}}>
                {categories.map((category, index) => {
                    const categoryOdds = groupedOdds[category];

                    const isOpen = openCategory === category;

                    return (
                        <div
                            key={index}
                            className="bg-white border rounded-3xl shadow-sm overflow-hidden"
                        >
                            {/* Category Header */}
                            <button
                                onClick={() =>
                                    setOpenCategory(isOpen ? null : category)
                                }
                                className="w-full flex items-center justify-between p-5 hover:bg-gray-50 transition-all"
                            >
                                <div className="flex items-center gap-3">
                                    <div className="bg-blue-100 p-2 rounded-xl">
                                        <TrendingUp className="w-5 h-5 text-blue-600" />
                                    </div>

                                    <div className="text-left">
                                        <h2 className="font-bold text-lg text-gray-800">
                                            {category}
                                        </h2>

                                        <p className="text-sm text-gray-500">
                                            {categoryOdds.length} odds available
                                        </p>
                                    </div>
                                </div>

                                {isOpen ? (
                                    <ChevronUp className="w-5 h-5 text-gray-600" />
                                ) : (
                                    <ChevronDown className="w-5 h-5 text-gray-600" />
                                )}
                            </button>

                            {/* Odds List */}
                            {isOpen && (
                                <div className="border-t">
                                    <div className="overflow-x-auto">
                                        <table className="w-full min-w-[700px]">
                                            <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="text-left p-4 text-sm font-semibold text-gray-600">
                                                        Type
                                                    </th>

                                                    <th className="text-left p-4 text-sm font-semibold text-gray-600">
                                                        Handicap
                                                    </th>

                                                    <th className="text-left p-4 text-sm font-semibold text-gray-600">
                                                        Value
                                                    </th>

                                                    <th className="text-left p-4 text-sm font-semibold text-gray-600">
                                                        Status
                                                    </th>

                                                    <th className="text-left p-4 text-sm font-semibold text-gray-600">
                                                        Updated
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {categoryOdds.map((item, i) => (
                                                    <tr
                                                        key={i}
                                                        className="border-t hover:bg-gray-50 transition-all"
                                                    >
                                                        {/* Type */}
                                                        <td className="p-4">
                                                            <div className="font-semibold text-gray-800">
                                                                {item.type}
                                                            </div>
                                                        </td>

                                                        {/* Handicap */}
                                                        <td className="p-4">
                                                            <span className="bg-gray-100 px-3 py-1 rounded-full text-sm">
                                                                {item.handicap || "-"}
                                                            </span>
                                                        </td>

                                                        {/* Value */}
                                                        <td className="p-4">
                                                            <div className="font-bold text-lg text-blue-600">
                                                                {item.value}
                                                            </div>
                                                        </td>

                                                        {/* Status */}
                                                        <td className="p-4">
                                                            {item.suspended === "No" ? (
                                                                <div className="inline-flex items-center gap-2 bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                                                                    <ShieldCheck className="w-4 h-4" />
                                                                    Active
                                                                </div>
                                                            ) : (
                                                                <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-3 py-1 rounded-full text-sm font-medium">
                                                                    <Ban className="w-4 h-4" />
                                                                    Suspended
                                                                </div>
                                                            )}
                                                        </td>

                                                        {/* Time */}
                                                        <td className="p-4">
                                                            <div className="flex items-center gap-2 text-sm text-gray-500">
                                                                <Clock3 className="w-4 h-4" />

                                                                {item.upd}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MatchOdds;